import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Alert, Button, Card, Form, Select, TimePicker } from "antd"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { createTimeSlot } from "../../store/slices/timeSlotSlice";

const AddTimeSlot = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const [buttonLoading, setButtonLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const handleFinish = async (values) => {
        setButtonLoading(true);
        const time_slot = []
        values?.time_slot?.map((data) => {
            const startTime = data?.start_time.format("HH:mm")
            const endTime = data?.end_time.format("HH:mm")
            time_slot.push({ start_time : startTime, end_time : endTime })
        })
        let data = {
            day: values?.day,
            time_slot
        }
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const resultAction = await dispatch(createTimeSlot(data))
            if (createTimeSlot.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Time slot created successfully');
                setAlertType('success');
                form.resetFields();
                setTimeout(() => {
                    setAlertMessage("")
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating time slot');
                setAlertType('error');
            }
        } catch (error) {
            // message.error('Failed to submit job form.');
            setAlertMessage('Failed to submit time slot form');
            setAlertType('error');
        } finally {
            setButtonLoading(false);
        }
    };
    return (
        <Card title="Create Time Slot" bordered={false}>
            {alertMessage && (
                <Alert
                    message={alertMessage}
                    type={alertType}
                    showIcon
                    icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    closable
                    onClose={() => setAlertMessage('')}
                    style={{
                        marginBottom: 24,
                        borderRadius: '8px',
                    }}
                />
            )}
            <Form
                layout="vertical"
                form={form}
                onFinish={handleFinish}
                initialValues={{
                    time_slot: [{}]  // 👈 One row by default
                }}
            >
                <Form.Item
                     label="Day"
                     name="day"
                     rules={[{ required: true, message: 'Please select day' }]}
                >
                    <Select
                        placeholder="Select day"
                        options={[
                            { value : "Mon", label : "Mon" },
                            { value : "Tue", label : "Tue" },
                            { value : "Wed", label : "Wed" },
                            { value : "Thu", label : "Thu" },
                            { value : "Fri", label : "Fri" },
                            { value : "Sat", label : "Sat" },
                            { value : "Sun", label : "Sun" }
                        ]}
                    />
                </Form.Item>
                <Form.List name="time_slot">
                {(fields, { add, remove }) => (
                    <>
                    {fields.map((field, index) => (
                        <Card
                        key={field.key}
                        style={{ marginBottom: 20, background: "#fafafa" }}
                        >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <h4>Time Slot #{index + 1}</h4>
                            {index > 0 && (
                            <Button danger onClick={() => remove(field.name)}>
                                Remove
                            </Button>
                            )}
                        </div>
                            <Form.Item
                                {...field}
                                label="Start Time"
                                name={[field.name, "start_time"]}
                                fieldKey={[field.fieldKey, "start_time"]}
                                rules={[{ required: true, message: "Select start time" }]}
                            >
                                <TimePicker style={{ width: '100%' }} format="HH:mm" />
                            </Form.Item>
                            <Form.Item
                                {...field}
                                label="End Time"
                                name={[field.name, "end_time"]}
                                fieldKey={[field.fieldKey, "end_time"]}
                                rules={[{ required: true, message: "Select end time" }]}
                            >
                                <TimePicker style={{ width: '100%' }} format="HH:mm" />
                            </Form.Item>
                        </Card>
                    ))}

                    <Button type="dashed" onClick={() => add()} block>
                        + Add Another Time Slot
                    </Button>
                    </>
                )}
                </Form.List>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={buttonLoading}
                        style={{ marginTop: 16 }}
                    >
                    Submit
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

export default AddTimeSlot